import { Injectable } from '@angular/core';
import { fromEvent, merge, Subscription, timer } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class InactivityService {
  private inactivityTimeout = 60 * 60 * 1000; // 60 minutes
  private activitySubscription: Subscription;
  private activityTimerSubscription: Subscription;

  constructor() {
    this.startActivityDetection();
    this.startInactivityTimer(); // Start the inactivity timer immediately
  }

  private startActivityDetection() {
    // Create observables for each event
    const mouseMove$ = fromEvent(document, 'mousemove');
    const keyDown$ = fromEvent(document, 'keydown');
    const scroll$ = fromEvent(document, 'scroll');
    const click$ = fromEvent(document, 'click');
    const touchStart$ = fromEvent(document, 'touchstart');

    // Merge all event observables
    const events$ = merge(mouseMove$, keyDown$, scroll$, click$, touchStart$);

    this.activitySubscription = events$.subscribe(() => {
      this.resetInactivityTimer(); // Reset the inactivity timer on activity
    });
  }

  private startInactivityTimer() {
    this.activityTimerSubscription = timer(this.inactivityTimeout).subscribe(
      () => {
        this.reloadPage();
      },
    );
  }

  private resetInactivityTimer() {
    // Unsubscribe from the previous timer and start a new one
    if (this.activityTimerSubscription) {
      this.activityTimerSubscription.unsubscribe();
    }
    this.startInactivityTimer();
  }

  ngOnDestroy() {
    // Clean up the subscriptions
    if (this.activitySubscription) {
      this.activitySubscription.unsubscribe();
    }
    if (this.activityTimerSubscription) {
      this.activityTimerSubscription.unsubscribe();
    }
  }

  private reloadPage() {
    console.log('Reloading page due to inactivity');
    location.reload();
  }
}
